import { gql } from '@apollo/client';

export default gql`
  mutation exoForgetPassword($email: String!) {
    exoForgetPassword(email: $email)
  }
`;
